import { FormTemplate } from 'data/template/template.types';

export const genbandTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'af-genband-c20-01',
  key: 'af-genband-c20-01',
  tag: 'genband-c20',
  general: {
    metadata: {
      layout: {
        rows: [
          [
            'targetDeliveryTemplate',
          ],

        ],
      },
    },
    fields: {
      targetDeliveryTemplate: {
        type: 'select',
        label: 'Target Delivery Template',
        hintMessage: 'The template is used to pre-populate the fields below.',
        initial: '',
        optionsFirstTranslatable: true,
        options: [],
      },

    },
  },
  targetInformation: {
    metadata: {
      layout: {
        rows: [
          ['GRPID', 'LIID'],
          ['ACC', 'LTID'],
          ['CDCTGTDN', 'MONOMODE'],
          ['PNI', '$empty'],
        ],
      },
    },
    fields: {
      GRPID: {
        label: 'Group ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
        },
      },
      LIID: {
        label: 'LIID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
        },
      },
      ACC: {
        label: 'Target Access Type',
        type: 'select',
        initial: 'BRI',
        options: [
          {
            label: 'IBN',
            value: 'IBN',
          },
          {
            label: 'BRI',
            value: 'BRI',
          },
          {
            label: 'PRI',
            value: 'PRI',
          },
          {
            label: 'MFT',
            value: 'MFT',
          },
          {
            label: 'VA',
            value: 'VA',
          },
          {
            label: 'Hunt Member',
            value: 'HNT',
          },
          {
            label: 'Trunk',
            value: 'TRK',
          },
        ],
      },
      CDCTGTDN: {
        label: 'CDR Includes DN',
        type: 'checkbox',
        initial: true,
      },
      MONOMODE: {
        label: 'CC Delivered in MONO',
        type: 'checkbox',
        initial: true,
      },
      PNI: {
        label: 'Enable PNI',
        type: 'checkbox',
        initial: true,
      },
      VARIANT: {
        label: 'Protocol Variant',
        type: 'select',
        initial: 'ETSIPRI',
        disabled: true,
        options: [
          {
            label: 'ETSIPRI',
            value: 'ETSIPRI',
          },
          {
            label: 'QSIGPRI',
            value: 'QSIGPRI',
          },
          {
            label: 'AUSTPRI',
            value: 'AUSTPRI',
          },
          {
            label: 'FDCP',
            value: 'FDCP',
          },
          {
            label: 'CDN_OUT_NATL',
            value: 'CDN_OUT_NATL',
          },
          {
            label: 'CDN_OUT_INTL',
            value: 'CDN_OUT_INTL',
          },
          {
            label: 'CDN_IN_NATL',
            value: 'CDN_IN_NATL',
          },
          {
            label: 'CLI_IN_INTL',
            value: 'CLI_IN_INTL',
          },
          {
            label: 'CLLI_IN_CLLI',
            value: 'CLLI_IN_CLLI',
          },
          {
            label: 'CLLI_OUT_CLLI',
            value: 'CLLI_OUT_CLLI',
          },
        ],
      },
      CLLI: {
        label: 'Common Language Location ID',
        type: 'text',
        disabled: true,
        initial: '',
        hide: 'false',
      },
      LTID: {
        label: 'Logical Terminal ID',
        type: 'text',
        disabled: true,
        initial: '',
      },
      LEN: {
        label: 'Hunt Member Length',
        type: 'text',
        disabled: true,
        initial: '',
      },
      FDCP: {
        label: 'FDCP',
        type: 'text',
        disabled: true,
        initial: '',
      },
      CGNDN: {
        label: 'Calling DN',
        type: 'text',
        disabled: true,
        initial: '',
        validators: [
          {
            type: 'length',
            length: 18,
            errorMessage: 'Exceeds maximum length, 18.  Please re-enter.',
          },
        ],
      },
      CDNDN: {
        label: 'Called DN',
        type: 'text',
        disabled: true,
        initial: '',
        validators: [
          {
            type: 'length',
            length: 18,
            errorMessage: 'Exceeds maximum length, 18.  Please re-enter.',
          },
        ],
      },
    },
  },
  callContentChannels: {
    metadata: {
      layout: {
        rows: [
          ['IDN', 'NAME'],
          ['SYS', 'BILLNO'],
          ['MAXINTERCEPT', 'STATICCCC'],
          ['CGSA', 'BC'],
          ['REQ', 'AUTH'],
          ['CUG', 'SANREQ'],
          ['SAN', '$empty'],
        ],
      },
    },
    fields: {
      IDN: {
        label: 'Individual CCC DN',
        type: 'text',
        initial: '',
      },
      NAME: {
        label: 'CCC Translation Name',
        type: 'text',
        initial: '',
      },
      SYS: {
        label: 'Translation System Name',
        type: 'text',
        initial: '',
      },
      BILLNO: {
        label: 'CCC Billing',
        type: 'text',
        initial: '',
      },
      MAXCCC: {
        label: 'Max CCC Pairs (4-255)',
        type: 'text',
        disabled: true,
        initial: '4',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [[4, 255]],
              errorMessage: 'Must be between 1024 - 65535. Please re-enter.',
            },
          ],
        },
      },
      PREPENDRTEDIGS: {
        label: 'Enable Prepend Routing Digits',
        disabled: true,
        type: 'checkbox',
        initial: false,
      },
      NUMRTEDIGS: {
        label: 'Number Of Digits',
        type: 'select',
        initial: '0',
        disabled: true,
        options: [
          {
            label: '0',
            value: '0',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
          {
            label: '3',
            value: '3',
          },
          {
            label: '4',
            value: '4',
          },
          {
            label: '5',
            value: '5',
          },
          {
            label: '6',
            value: '6',
          },
          {
            label: '7',
            value: '7',
          },
        ],
      },
      MAXINTERCEPT: {
        label: 'Max Intercepts',
        type: 'text',
        initial: '',
      },
      STATICCCC: {
        label: 'Static CCCs',
        type: 'text',
        initial: '',
      },
      CGSA: {
        label: 'Calling Party Sub-Address',
        type: 'select',
        initial: 'REFNO',
        options: [
          {
            label: 'Target DN',
            value: 'TGTDN',
          },
          {
            label: 'Reference Number',
            value: 'REFNO',
          },
          {
            label: 'none',
            value: 'NONE',
          },
        ],
      },
      BC: {
        label: 'Bearer Capability',
        type: 'select',
        initial: 'SPEECH',
        options: [
          {
            label: 'Speech',
            value: 'SPEECH',
          },
          {
            label: '64K Data',
            value: '64K_DATA',
          },
        ],
      },
      REQ: {
        label: 'Require CCC Links',
        type: 'checkbox',
        initial: true,
      },
      AUTH: {
        label: 'Use Authentication',
        type: 'checkbox',
        initial: true,
      },
      CUG: {
        label: 'Enable Closed User Group',
        type: 'checkbox',
        initial: true,
      },
      SANREQ: {
        label: 'Enable Secondary Authentication Number',
        type: 'checkbox',
        initial: false,
      },
      SAN: {
        label: 'Secondary Auth Number ',
        type: 'text',
        initial: '',
        disabled: true,
      },
    },
  },
};

export const GENBAND_TARGET_CCC_ROWS = {
  targetInformation: {
    IBN: [
      ['GRPID', 'LIID'],
      ['ACC', '$empty'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
    BRI: [
      ['GRPID', 'LIID'],
      ['ACC', 'LTID'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
    PRI: [
      ['GRPID', 'LIID'],
      ['ACC', 'VARIANT', 'LTID'],
      ['CLLI', 'FDCP'],
      ['CGNDN', 'CDNDN'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
    MFT: [
      ['GRPID', 'LIID'],
      ['ACC', '$empty'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
    HNT: [
      ['GRPID', 'LIID'],
      ['ACC', 'LEN'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
    TRK: [
      ['GRPID', 'LIID'],
      ['ACC', 'VARIANT'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
    VA: [
      ['GRPID', 'LIID'],
      ['ACC', '$empty'],
      ['CDCTGTDN', 'MONOMODE'],
      ['PNI', '$empty'],
    ],
  },
  callContentChannels: {
    IBN: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
    BRI: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
    PRI: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['PREPENDRTEDIGS', 'NUMRTEDIGS'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
    MFT: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
    VA: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['MAXCCC', '$empty'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
    HNT: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
    TRK: [
      ['IDN', 'NAME'],
      ['SYS', 'BILLNO'],
      ['MAXCCC', '$empty'],
      ['PREPENDRTEDIGS', 'NUMRTEDIGS'],
      ['MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC'],
      ['REQ', 'AUTH'],
      ['CUG', 'SANREQ'],
      ['SAN', '$empty'],
    ],
  },
};

export default genbandTemplate;
